import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from 'store';
import { Scaffold } from 'layouts';
import { FormPageHeader } from 'components/Shared';
import { SetupUpdateForm } from 'components/Pages/VehicleSetups';
import * as S from './styles';

export const VehicleSetupUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const { loading } = useSelector(
    (state: RootState) => state.fetchVehicleSetup
  );

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/setups-veiculos');
  }, [navigate]);

  return (
    <Scaffold>
      <S.PageContainer>
        <S.MainPanel>
          <FormPageHeader
            title="Editar setup de veículo"
            icon={<S.TruckIcon />}
            isLoading={loading}
            actions={
              <S.LinkButton size="small" to="/configuracoes/setups-veiculos">
                <S.ArrowLeftIcon /> Voltar
              </S.LinkButton>
            }
          />
          <SetupUpdateForm setupId={id} onUpdate={onUpdate} />
        </S.MainPanel>
      </S.PageContainer>
    </Scaffold>
  );
};
